import { BOOKINGS_APP_DEF_ID, BOOKINGS_LIST_SECTION_ID, BOOKINGS_SCHEDULER_SECTION_ID, isBookingsSectionInstalled } from '@wix/bookings-catalog-calendar-viewer-utils';
async function isBookOnlineInstalled(wixCodeApi) {
  return isBookingsSectionInstalled(wixCodeApi, BOOKINGS_LIST_SECTION_ID);
}
async function getBookOnlineRelativeUrl(wixCodeApi) {
  const bookOnlineFullUrl = await getBookOnlineFullUrl(wixCodeApi);
  const baseUrl = wixCodeApi.location.baseUrl;
  const urlParts = bookOnlineFullUrl.split(baseUrl);
  const bookOnlineRelativeUrl = urlParts.length > 1 ? urlParts[1] : bookOnlineFullUrl;
  return bookOnlineRelativeUrl;
}
async function getBookOnlineFullUrl(wixCodeApi) {
  const bookOnlineFullUrl = (await wixCodeApi.site.getSectionUrl({
    sectionId: (await isBookOnlineInstalled(wixCodeApi)) ? BOOKINGS_LIST_SECTION_ID : BOOKINGS_SCHEDULER_SECTION_ID,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  })).url;
  return bookOnlineFullUrl;
}
export async function navigateToServiceListWithQuery(_ref) {
  let {
    wixCodeApi,
    queryName,
    queryValue
  } = _ref;
  const bookOnlineRelativeUrl = await getBookOnlineRelativeUrl(wixCodeApi);
  wixCodeApi.location.to(`${bookOnlineRelativeUrl}?${queryName}=${queryValue}`);
}
export async function navigateToServiceList(_ref2) {
  let {
    wixCodeApi
  } = _ref2;
  const bookOnlineRelativeUrl = await getBookOnlineRelativeUrl(wixCodeApi);
  wixCodeApi.location.to(bookOnlineRelativeUrl);
}
//# sourceMappingURL=navigateToServiceList.js.map